/**
 * Full re-sync confirmation — frame 15. Ports the same warning the legacy
 * window.confirm used to state (wipes synced data, re-pulls from
 * scratch), now as a themed modal rather than window.confirm.
 */
import React from "react";
import ConfirmDialog from "../../theme/untitled/ConfirmDialog/ConfirmDialog";
import Icon from "../../theme/untitled/icons/Icon";
import { getSourceName } from "../DashboardPage/CalendarSourcesWidget/utils";

const FullResyncDialog = ({ integration, busy, onClose, onConfirm }) => (
  <ConfirmDialog
    open={Boolean(integration)}
    onClose={onClose}
    onConfirm={onConfirm}
    variant="warning"
    icon={<Icon name="RefreshCcw05" size={24} />}
    title={integration ? `Full re-sync ${getSourceName(integration)}?` : ""}
    confirmLabel="Start full re-sync"
    busy={busy}
  >
    <p>
      This wipes your synced data and syncs everything from scratch. It may take
      a few minutes, and your widgets won&rsquo;t show items from this source
      while it runs.
    </p>
  </ConfirmDialog>
);

export default FullResyncDialog;
